import { ScrollView, View } from 'react-native';

import { ForgotPasswordForm } from '@/components/forgot-password-form';

export default function ForgotPasswordScreen() {
  return (
    <ScrollView
      keyboardShouldPersistTaps="handled"
      contentContainerClassName="items-center justify-center p-4 py-8 sm:flex-1 sm:p-6 sm:py-4"
      contentInsetAdjustmentBehavior="automatic"
      keyboardDismissMode="interactive"
      className="flex-1 bg-background"
    >
      <View className="w-full max-w-sm">
        <ForgotPasswordForm />
      </View>
    </ScrollView>
  );
}
